import {SPRING_5} from '@gaia/colors';
import theme from '@gaia/theme';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import {Fade, type FadeProps, Typography} from '@mui/material';

interface AuthSuccessProps extends Pick<FadeProps, 'in'> {
    message: string;
}

export default function AuthSuccess({message, ...props}: AuthSuccessProps) {
    return (
        <Fade
            {...props}
            timeout={750}
            style={{
                display: 'flex',
            }}
        >
            <div>
                <div
                    style={{
                        display: 'flex',
                        height: 275,
                        width: 275,
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'column',
                    }}
                >
                    <CheckCircleOutlineIcon
                        style={{
                            fontSize: 120,
                            color: SPRING_5,
                            marginBottom: theme.spacing(2),
                        }}
                    />
                    <Typography variant='h4' color='primary'>
                        {message}
                    </Typography>
                </div>
            </div>
        </Fade>
    );
}
